/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import BaseCom from "./BaseCom";
import Card from "./Card";
import FormInput from "./FormInput";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { v4 as uuidv4 } from 'uuid';
import React from "react";
import Globals from "../shared/Globals";
import Icon from "./Icon";
import { Alert } from "react-bootstrap";
import { ImageGalleryOverlayGlobal } from "./ImageGalleryOverlay";

export default class ExaminationWound extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            woundPosRect: {},
            woundPosFeetRect: {}
        };
        this.uploadRef = React.createRef();
        this.uploadCameraRef = React.createRef();
        this.onChange = this.onChange.bind(this);
        this.selectWoundPos = this.selectWoundPos.bind(this);
        this.selectWoundPosFeet = this.selectWoundPosFeet.bind(this);
        this.updateSizes = this.updateSizes.bind(this);
        this.removeWound = this.removeWound.bind(this);
        this.triggerUploadPhoto = this.triggerUploadPhoto.bind(this);
        this.uploadPhoto = this.uploadPhoto.bind(this);
    }

    componentDidMount() {
        this.resizeEvent = () => {
            this.updateSizes();
        };

        window.addEventListener('resize', this.resizeEvent);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeEvent);
    }

    onChange() {
        this.props.onChange();
    }

    reEnumerateWounds(list, feetList) {
        this.woundIdx = 1;
        list.forEach(i => {
            i.idx = this.woundIdx;
            this.woundIdx++;
        });
        feetList.forEach(i => {
            i.idx = this.woundIdx;
            this.woundIdx++;
        });
    }

    selectWoundPos(e) {
        if (this.props.disabled)
            return;
        var rect = e.target.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;

        var px = x / rect.width;
        var py = y / rect.height;

        console.log(e, { x: px, y: py, key: uuidv4() });
        this.woundIdx++;

        this.props.item.woundPosList.push({ x: px, y: py, key: uuidv4(), idx: this.woundIdx, context: 'body' });

        this.reEnumerateWounds(this.props.item.woundPosList, this.props.item.woundPosFeetList);
        this.setState({ woundPosList: this.props.item.woundPosList });
        if (this.props.onSelectWound)
            this.props.onSelectWound();
    }

    selectWoundPosFeet(e) {
        if (this.props.disabled)
            return;

        var rect = e.target.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;

        var px = x / rect.width;
        var py = y / rect.height;

        console.log(e, { x: px, y: py, key: uuidv4() });
        this.woundIdx++;

        this.props.item.woundPosFeetList.push({ x: px, y: py, key: uuidv4(), idx: this.woundIdx, context: 'feet' });

        this.reEnumerateWounds(this.props.item.woundPosList, this.props.item.woundPosFeetList);
        this.setState({ woundPosFeetList: this.props.item.woundPosFeetList });
        if (this.props.onSelectWound)
            this.props.onSelectWound();
    }

    updateSizes() {
        try {
            var wp = document.getElementById('Examination-WoundPos').getBoundingClientRect();
            var wpf = document.getElementById('Examination-WoundPosFeet').getBoundingClientRect();
            this.setState({ woundPosRect: wp, woundPosFeetRect: wpf });
        }
        catch { }
    }


    removeWound(i) {
        // eslint-disable-next-line no-restricted-globals
        if (!confirm('Are you sure you want to remove wound ' + i.idx + '?'))
            return;
        var item = this.props.item;

        if (i.context === 'feet') {
            item.woundPosFeetList.splice(item.woundPosFeetList.indexOf(i), 1);
            this.setState({ item: item });
        }
        else /* if (i.context === 'body') */ {
            item.woundPosList.splice(item.woundPosList.indexOf(i), 1);
            this.setState({ item: item });
        }

        this.reEnumerateWounds(this.props.item.woundPosList, this.props.item.woundPosFeetList);
        this.setState({ woundPosList: this.props.item.woundPosList, woundPosFeetList: this.props.item.woundPosFeetList });
    }

    triggerUploadPhoto(i, useCamera) {
        this.setState({ currentWound: i });
        if(useCamera)
            this.uploadCameraRef.current.click();
        else
            this.uploadRef.current.click();
    }


    uploadPhoto(e) {
        this.setState({ uploading: true });
        var reader = new FileReader();
        reader.readAsBinaryString(e.target.files[0]);
        reader.onload = () => {
            var b64data = btoa(reader.result);
            var item = { ...this.state.currentWound };
            item.fileName = e.target.files[0].name;
            item.mimeType = e.target.files[0].type;
            item.dataSize = e.target.files[0].size;
            item.base64Content = b64data;
            if(!item.images) item.images = [];
            item.images.splice(0,0,{ displayFileName: item.fileName, mimeType: item.mimeType, base64Content: item.base64Content });


            this.uploadRef.current.value = '';

            this.props.onWoundPhotoChanged?.(item);

            this.setState({ uploading: false });
        };
        reader.onerror = (error) => {
            console.log('Error: ', error);
            this.setState({ uploading: false });
            e.target.value = '';
        };

    }
    
    filterImageGallery = (images) => {
        if(!images) return [];
        return images.filter(i => i.base64Content || i.fileIdent);
    }
    
    showImageGallery = (i) => {
        if(!i.images || i.images.length === 0) return;
        let images = this.filterImageGallery([...i.images]);
        images.forEach(i => i.url = i.base64Content ? 'data:' + i.mimeType + ';base64,' + i.base64Content : Globals.serverUrl + '/api/storage/image/' + i.fileIdent);
        if(images.length === 0) return;
        ImageGalleryOverlayGlobal.show(images, (images,index) => this.deleteWoundImage(i, images,index));
    }

    deleteWoundImage = (wound, images, index) => {
        let item = wound;        
        item.images.splice(index, 1);
        this.setState({ currentWound: item });
        this.props.onWoundPhotoChanged?.(item);
    }

    resetPhotos = (wound) => {
        let item = wound;
        item.base64Content = null;
        item.fileIdent = null;
        item.images = [];
        this.setState({ currentWound: item });
        this.props.onWoundPhotoChanged?.(item);
    }

    render() {
        var woundList = [...this.props.item.woundPosList].concat(this.props.item.woundPosFeetList);

        return <>
            <input type="file" className="d-none" ref={this.uploadCameraRef} accept="image/*" capture="camera" onChange={this.uploadPhoto} />
            <input type="file" className="d-none" ref={this.uploadRef} accept="image/*" onChange={this.uploadPhoto} />
            
            <Card title="Wound Positions">
                <div className="row text-center">
                    <div className="col-md-6">
                        <div className="position-relative img-click">
                            {this.props.item.woundPosList.map(i => <div key={i.key} className="position-absolute" style={{ left: (i.x * 100) + '%', top: (i.y * 100) + '%', marginLeft: '-7px', marginTop: '-7px' }}>
                                <div className="bg-primary rounded text-light p-1">{i.idx}</div>
                            </div>)}                            
                            <img id="Examination-WoundPos" src="/img/wounds/wound-pos.png" className="w-100" alt="" onClick={this.selectWoundPos} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="position-relative img-click">
                            {this.props.item.woundPosFeetList.map(i => <div key={i.key} className="position-absolute" style={{ left: (i.x * 100) + '%', top: (i.y * 100) + '%', marginLeft: '-7px', marginTop: '-7px' }}>
                                <div className="bg-primary rounded text-light p-1">{i.idx}</div>
                            </div>)}
                            <img id="Examination-WoundPosFeet" src="/img/wounds/wound-pos-feet.png" className="w-100" alt="" onClick={this.selectWoundPosFeet} />
                        </div>
                    </div>
                </div>

                {woundList.map(i =>
                    <div className="my-2 exam-wound" key={i.idx}>
                        <div className="row align-items-start">
                            <div className="col-sm-1 text-start text-sm-center py-3">
                                <strong className="text-primary bolder d-inline-block p-2">#{i.idx}</strong>
                                {!this.props.disabled ? <span className="ms-2 bg-danger p-2 rounded text-light d-inline-block" role="button" title="Delete" onClick={() => this.removeWound(i)}><FontAwesomeIcon icon={fa.faTrash} /></span> : ''}
                            </div>
                            <div className="col-md-8">
                                <div className="row">
                                    <div className="col-md">
                                        <FormInput model={i} name="position" label="Wound Position" type="text" onChange={this.onChange} disabled={this.props.disabled} />
                                    </div>
                                    <div className="col-md">
                                        <label className="form-label">Size</label>
                                        <div className="d-flex align-items-center gap-1">
                                            <FormInput model={i} name="sizeLength" label="L" type="number" onChange={this.onChange} disabled={this.props.disabled} labelAsPlaceholder />
                                            <div className="mb-3">X</div>
                                            <FormInput model={i} name="sizeWidth" label="W" type="number" onChange={this.onChange} disabled={this.props.disabled} labelAsPlaceholder />
                                            <div className="mb-3">X</div>
                                            <FormInput model={i} name="sizeDepth" label="D" type="number" onChange={this.onChange} disabled={this.props.disabled} labelAsPlaceholder />
                                        </div>
                                        <div className="text-center mb-3">
                                            {i.sizeLength && i.sizeWidth ? <span className="text-primary">Area: {i.sizeLength * i.sizeWidth} cm<sup>2</sup></span> : <i>Not Data to Calculate</i>}
                                        </div>
                                    </div>
                                    <div className="col-md">
                                        <FormInput model={i} name="tunneling" label="Tunneling/undermining (cm)" type="text" onChange={this.onChange} disabled={this.props.disabled} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md">
                                        <FormInput model={i} name="bedGranulation" label="Wound Bed Granulation (%)" type="text" onChange={this.onChange} disabled={this.props.disabled} />
                                    </div>
                                    <div className="col-md">
                                        <FormInput model={i} name="bedSlough" label="Wound Bed Slough (%)" type="text" onChange={this.onChange} disabled={this.props.disabled} />
                                    </div>
                                    <div className="col-md">
                                        <FormInput model={i} name="bedEschar" label="Wound Bed Eschar (%)" type="text" onChange={this.onChange} disabled={this.props.disabled} />
                                    </div>
                                    <div className="col-md">
                                        <FormInput model={i} name="bedOther" label="Wound Bed Other (%)" type="text" onChange={this.onChange} disabled={this.props.disabled} />
                                        {i.bedOther ? <FormInput model={i} name="bedOtherMore" label="Details" type="text" onChange={this.onChange} disabled={this.props.disabled} /> : ''}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md">
                                        <FormInput model={i} name="drainageSel" label="Drainage" type="select" options={[
                                            { id: 'None', name: 'None' },
                                            { id: 'Serous', name: 'Serous' },
                                            { id: 'Serosanguineous', name: 'Serosanguineous' },
                                            { id: 'Purulent', name: 'Purulent' },
                                            { id: 'Sanguineous', name: 'Sanguineous' },
                                            { id: 'Fibrinous', name: 'Fibrinous' },
                                            { id: 'Other', name: 'Other' }
                                        ]} onChange={this.onChange} disabled={this.props.disabled} />
                                        {i.drainage || i.drainageSel === 'Other' ? <FormInput model={i} name="drainage" label="Drainage (Other)" type="text" onChange={this.onChange} disabled={this.props.disabled} /> : null}

                                    </div>
                                    <div className="col-md">
                                        <FormInput model={i} name="woundType" label="Type" type="text" onChange={this.onChange} disabled={this.props.disabled} />
                                    </div>
                                    <div className="d-none">
                                        <FormInput model={i} name="color" label="Color" type="text" onChange={this.onChange} disabled={this.props.disabled} />
                                    </div>
                                    <div className="d-none">
                                        <FormInput model={i} name="consistency" label="Consistency" type="text" onChange={this.onChange} disabled={this.props.disabled} />
                                    </div>
                                    <div className="col-md">
                                        {i.amount ? <FormInput model={i} name="amount" label="Amount (Legacy Field)" type="text" onChange={this.onChange} disabled={this.props.disabled} /> : null}
                                        <FormInput model={i} name="amountSel" label="Amount" type="select" options={[
                                            { id: 'None', name: 'None' },
                                            { id: 'Minimal', name: 'Minimal' },
                                            { id: 'Moderate', name: 'Moderate' },
                                            { id: 'Large', name: 'Large' },
                                            { id: 'Excessive', name: 'Excessive' }
                                        ]} onChange={this.onChange} disabled={this.props.disabled} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md">
                                        <FormInput model={i} name="edges" label="Edges" type="text" onChange={this.onChange} disabled={this.props.disabled} />
                                    </div>
                                    <div className="col-md">
                                        <FormInput model={i} name="odor" label="Odor" type="text" onChange={this.onChange} disabled={this.props.disabled} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md">
                                        <label className="form-label">Diag Codes</label>
                                        <FormInput model={i} name="diagCodes" label="Search for a Diag Code..." labelAsPlaceholder type="multisearch" searchUrl="/api/diagcode/search" onChange={this.onChange} disabled={this.props.disabled} />
                                    </div>
                                </div>
                                <FormInput model={i} name="notes" label="Wound Notes" type="textarea" onChange={this.onChange} disabled={this.props.disabled} />
                            </div>
                            <div className="col-md-3">
                                <div className="text-center">
                                    <div className="d-flex justify-content-center">
                                        <div role="button" onClick={() => this.showImageGallery(i)}>
                                            {i.base64Content ? <img src={'data:' + i.mimeType + ';base64,' + i.base64Content} alt="" className="img-fluid card-img-top" /> : i.fileIdent ? <img src={Globals.serverUrl + '/api/wound/image/' + i.fileIdent} className="img-fluid card-img-top" alt="" /> : <img src="/img/placeholder.png" className="img-fluid card-img-top" alt="" />}
                                        </div>
                                    </div>
                                    {this.filterImageGallery(i.images)?.length > 0 && <div className="mt-1 text-center fst-italic">{this.filterImageGallery(i.images).length} images</div>}
                                    {!this.props.disabled && <div className="mt-1">
                                        <button type="button" className="btn btn-primary d-inline-block d-md-none" onClick={() => this.triggerUploadPhoto(i, true)} disabled={this.props.disabled}><Icon icon="faCamera" /> Take Photo</button>
                                        <button type="button" className="btn btn-primary" onClick={() => this.triggerUploadPhoto(i, false)} disabled={this.props.disabled}><Icon icon="faUpload" /> Upload Photo</button>
                                        <button type="button" className="btn btn-danger" onClick={() => this.resetPhotos(i)} disabled={this.props.disabled}>Reset</button>
                                    </div>}
                                </div>

                            </div>
                        </div>

                    </div>)}
            </Card>
        </>;
    }
}